// Central registry of feature codes used by the FeatureAccess slice.

export default {
  DISPLAY_ADMIN_PAGE: 'display_admin_page',
  EDIT_VESSEL_DRAFT: 'edit_vessel_draft',
  ENABLE_FEATURE_TOGGLE_VIEW: 'enable_feature_toggle_view',
  SHOW_BAPLIE_OR_RESTOW_COMPONENT: 'show_baplie_or_restow_component',
  SHOW_CONTAINER_NOTES: 'show_container_notes',
  SHOW_DEVICE_DETAILS: 'show_device_details',
  SHOW_FLEET_CONTACT_INFO: 'show_fleet_contact_info',
  UPLOAD_BAPLIE_OR_RESTOW: 'upload_baplie_or_restow',
}
